<template>
  <div>
    <div class="w-full text-center" v-if="loading">
      <div class="py-5">
        <h1 class="text-2xl">
          <i class="fa fa-circle-notch fa-spin text-white"></i>
        </h1>
      </div>
    </div>

    <div
      class="grid grid-cols-1 gap-4 items-start lg:grid-cols-3 lg:gap-8 mb-4 lg:mb-8"
      v-if="!loading"
    >
      <div class="grid grid-cols-1 gap-4 lg:col-span-2 h-full">
        <!-- This example requires Tailwind CSS v2.0+ -->
        <div
          class="bg-white overflow-hidden shadow rounded-lg divide-y divide-gray-200"
        >
          <div class="px-4 py-5 sm:px-6 flex flex-row space-x-4 items-center">
            <AccountIcon
              :initials="announcement.sender.name | initials(' ')"
              :size="10"
            />
            <div class="flex flex-col">
              <h1 class="text-lg font-medium">{{ announcement.title }}</h1>
              <span class="text-sm text-gray-600">{{
                announcement.created_at
                  | displayLocalDateTime("MMMM Do YYYY, h:mm a")
              }}</span>
            </div>
          </div>
          <div class="px-4 py-5 sm:p-6">
            <p style="white-space: pre-wrap;">{{ announcement.message }}</p>
          </div>
        </div>
      </div>
      <div class="grid grid-cols-1 gap-4 h-full">
        <!-- This example requires Tailwind CSS v2.0+ -->
        <div class="bg-white overflow-hidden shadow rounded-lg h-full">
          <div class="flex flex-col px-3 py-2">
            <div class="flex flex-row items-center px-2 py-3 border-b">
              <div class="flex-1">
                Category
              </div>
              <span>{{ announcement.category }}</span>
            </div>
            <div class="flex flex-row items-center px-2 py-3 border-b">
              <div class="flex-1">
                Views
              </div>
              <span>{{ announcement.viewsCount }}</span>
            </div>
            <div class="flex flex-row items-center px-2 py-3 border-b">
              <div class="flex-1">
                Comments
              </div>
              <span>{{ announcement.commentsCount }}</span>
            </div>
            <div class="flex flex-row items-center px-2 py-3">
              <div class="flex-1">Subscribe to updates?</div>
              <div class="flex flex-row items-center">
                <i
                  class="fa fa-circle-notch fa-spin text-black mr-2"
                  v-if="updatingNotificationSettings"
                ></i>
                <Toggle
                  :enabled="announcement.isSubscribedToNotifications"
                  color="blue"
                  @toggle="toggle"
                  :disabled="updatingNotificationSettings"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- chasers -->
    <div class="bg-white overflow-hidden shadow rounded-lg" v-if="!loading">
      <div class="px-4 py-5 sm:p-6">
        <h1 class="text-lg text-medium">Discussion</h1>
        <div class="w-full mt-6">
          <div class="flow-root">
            <ul class="-mb-8">
              <li
                v-for="(comment, index) in announcement.comments"
                v-bind:key="comment.id"
              >
                <div class="relative pb-8">
                  <span
                    class="absolute top-5 left-5 -ml-px h-full w-0.5 bg-gray-200"
                    aria-hidden="true"
                    v-if="index !== announcement.comments.length - 1"
                  ></span>
                  <div class="relative flex items-start space-x-3">
                    <div class="relative">
                      <AccountIcon
                        :initials="comment.sender.name | initials(' ')"
                      />

                      <span
                        class="absolute -bottom-0.5 -right-1 bg-white rounded-tl px-0.5 py-px"
                      >
                        <!-- Heroicon name: solid/chat-alt -->
                        <svg
                          class="h-5 w-5 text-gray-400"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                          aria-hidden="true"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M18 5v8a2 2 0 01-2 2h-5l-5 4v-4H4a2 2 0 01-2-2V5a2 2 0 012-2h12a2 2 0 012 2zM7 8H5v2h2V8zm2 0h2v2H9V8zm6 0h-2v2h2V8z"
                            clip-rule="evenodd"
                          />
                        </svg>
                      </span>
                    </div>
                    <div class="min-w-0 flex-1">
                      <div>
                        <div class="text-sm">
                          <div
                            class="flex flex-row items-center font-medium text-gray-900"
                          >
                            {{ comment.sender.name }}
                            <span
                              class="ml-2 px-2 py-0.5 bg-blue-100 rounded-full inline-block text-xs text-blue-600 font-light"
                              v-if="announcement.sender.id == comment.sender.id"
                              >Poster</span
                            >
                          </div>
                        </div>
                        <span
                          class="mt-0.5 text-sm text-gray-500"
                          :title="comment.created_at | displayLocalDateTime"
                          v-tippy
                        >
                          Commented {{ comment.created_at | timeAgo }}
                        </span>
                      </div>
                      <div class="mt-2 text-sm text-gray-700">
                        <p
                          v-html="comment.message"
                          v-linkified:options="{ className: 'text-blue-700' }"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>

          <div class="w-full" v-if="announcement.comments.length == 0">
            This announcement currently has no comments.
          </div>

          <div class="mt-10">
            <label
              for="comment"
              class="block text-sm font-medium text-gray-900"
            >
              Compose Comment
            </label>
            <div class="mt-1 space-y-2">
              <textarea
                id="comment"
                name="comment"
                rows="3"
                class="shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md"
                v-model="composeComment"
              ></textarea>
              <button
                class="bg-blue-700 px-3 py-1 text-white rounded"
                v-on:click="addComment()"
              >
                Comment
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="!loading">
      <div class="w-full mt-5 text-sm text-gray-500 ">
        <span class="text-uppercase inline-block"
          >Live Storms Media Disclaimers</span
        >
        <br />
        <ul>
          <li>
            Any views or opinions presented in this posting, and/or comments,
            are solely those of the author(s) and do not necessarily represent
            the views of Live Storms Media.
          </li>
          <li>
            CONFIDENTIALITY: This posting (including any attachments or comments
            within) may contain confidential, proprietary and privileged
            information, and unauthorized disclosure or use is prohibited.
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import * as Config from "@/config";

import AnnouncementReceipt from "@/components/general/AnnouncementReceipt";
import AccountIcon from "@/components/AccountIcon";

import Toggle from "@/components/Toggle";

export default {
  name: "AnnouncementView",
  data() {
    return {
      announcement: null,
      loading: true,
      composeComment: "",
      subscribeToNotifications: false,
      updatingNotificationSettings: false
    };
  },
  mounted() {
    this.getAnnouncement();
  },
  components: {
    AnnouncementReceipt,
    AccountIcon,
    Toggle
  },
  methods: {
    async getAnnouncement() {
      let res = await this.$http.get(
        Config.apiPath +
          "/api/v2/stringer/announcements/" +
          this.$route.params.uuid
      );
      this.announcement = res.data;
      this.loading = false;
    },
    addComment() {
      var userText = this.composeComment
        .replace(/^\s+/, "")
        .replace(/\s+$/, "");
      if (userText == "") {
        this.$swal(
          "Hang on!",
          "Blank comments are not permitted. To follow the conversation, enable updates.",
          "error"
        );
        return;
      }

      var _this = this;

      this.$http
        .post(
          Config.apiPath +
            "/api/v2/stringer/announcements/" +
            this.$route.params.uuid,
          { comment: this.composeComment }
        )
        .then(response => {
          _this.getAnnouncement();
          _this.composeComment = "";
        });
    },
    toggle() {
      this.updatingNotificationSettings = true;
      this.announcement.isSubscribedToNotifications = !this.announcement
        .isSubscribedToNotifications;
      let notificationUrl =
        Config.apiPath +
        "/api/v2/stringer/announcements/" +
        this.$route.params.uuid;

      if (this.announcement.isSubscribedToNotifications) {
        notificationUrl += "/subscribe";
      } else {
        notificationUrl += "/unsubscribe";
      }
      this.$http.post(notificationUrl, {}).then(response => {
        this.$set(this, "updatingNotificationSettings", false);
      });
    }
  }
};
</script>

<style scoped>
.user-panel {
  background-color: #f6f7f8;
}
</style>
